import { createFileRoute } from '@tanstack/react-router'
import LaunchPlanSection from 'Work/components/Work/Sections/LaunchPlan/LaunchPlanSection'

export const Route = createFileRoute('/work/$workId/launch-plan/')({
    component: LaunchPlanSection,
})
